module.exports = __webpack_public_path__ + "assets/svg/audio_ico.svg";